import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const IndividualReviewsContainer = styled.ul`
  padding: 0;
  font-size: ${fromTheme('font_size')};
  margin-top: ${fromTheme('spacing_large')};
`;

export const NoReviewsContainer = styled.div`
  margin-top: ${fromTheme('spacing_xlarge')};
  border-top: ${fromTheme('border_width')} ${fromTheme('border_style')}
    ${fromTheme('color_border')};
  padding: ${fromTheme('spacing_xlarge')} 0 ${fromTheme('spacing_large')} 0;
  text-align: center;
  color: ${fromTheme('color_text_secondary')};
  font-size: ${fromTheme('font_size')};
`;

export const NoResultsContainer = styled.div`
  max-width: 100%;
  overflow-wrap: break-word;
  overflow: auto;
  font-size: ${fromTheme('font_size')};
  color: ${fromTheme('color_text_secondary')};
  padding: ${fromTheme('spacing_large')} 0 ${fromTheme('spacing_medium')} 0;

  > span {
    margin-right: ${fromTheme('spacing_small')};
  }

  button {
    display: inline;
    color: ${fromTheme('color_link')};
  }
`;

export const IndividualReviewContainer = styled.li`
  list-style: none;
  border-bottom: ${fromTheme('border_width')} ${fromTheme('border_style')}
    ${fromTheme('color_border')};
  margin-bottom: ${fromTheme('spacing_large')};

  &:last-child {
    border-bottom: none;
  }
`;
